import { AfterViewInit, Directive, Input, OnDestroy, Optional, QueryList, Self } from "@angular/core";
import { AbstractControl, NgForm, NgModel } from "@angular/forms";
import { Subscription } from "rxjs";

@Directive({
    selector: 'form[editable-tooltip-dynamic-form]',
    exportAs: 'tooltipDynamicForm',
    standalone: false
})
export class EditableTooltipDynamicFormDirective implements AfterViewInit, OnDestroy {

    @Input() controls: QueryList<NgModel>;

    private currentControls: NgModel[] = [];
    private controlSubscription: Subscription;

    constructor(@Optional() @Self() private form: NgForm) {
    }

    ngAfterViewInit(): void {
        this.controlSubscription = this.controls.changes.subscribe(x => {
            setTimeout(() => this.setFormControls(), 0);            
        });

        setTimeout(() => this.setFormControls(), 0);        
    }

    ngOnDestroy(): void {
        if (this.controlSubscription) {
            this.controlSubscription.unsubscribe();
        }
    }

    isValid(): boolean {

        let valid: boolean = true;
        if (!this.form.valid) {
            const invalidControls: AbstractControl[] = [];
            invalidControls.push(...Object.keys(this.form.controls).map(x => this.form.controls[x]).filter(x => x.invalid));
            invalidControls.forEach(x => x.markAsTouched());
            valid = invalidControls.length == 0;
        }
        return valid;
    }

    private setFormControls() {
        if (this.currentControls.length) {
            this.currentControls.forEach(this.form.removeControl);
            this.currentControls.splice(0, this.currentControls.length);
        }

        this.controls.forEach((x: NgModel) => {
            this.form.addControl(x);
            this.currentControls.push(x);
        });
    }
}